/** @jsxRuntime classic */
/** @jsx jsx */
import { FC } from 'react';
import { jsx } from '@emotion/core';

import { Spinner } from '@zapier/design-system';
import styles from './styles';

type CenteredLoadingProps = {
  ariaLabel?: string;
};

/**
 * Renders a Spinner centered on the screen
 * @returns
 */
const CenteredLoading: FC<CenteredLoadingProps> = ({ ariaLabel }) => (
  <section aria-label={ariaLabel || 'Loading'} css={styles.root}>
    <Spinner size="large" />
  </section>
);

export default CenteredLoading;
